import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-circle',
  templateUrl: './add-circle.component.html',
  styleUrls: ['./add-circle.component.scss']
})
export class AddCircleComponent implements OnInit {
  colorMenu = false;

  colors = ['#E0E0E0', '#F28B82', '#FBBC04', '#FFF475', '#79C70C', '#A7FFEB', '#CBF0F8', '#1CB0F6', '#D7AEFB', '#F9A4D2', '#BC672C', '#D7D9DB']

  partSection = true;
  addSubPartSection = false;
  scanSection = false;

  showProgressBar = false;
  showSuccessMsg = false;
  progressBarValue = 0;
  constructor() { }

  ngOnInit() {
  }


  colorChange() {
    if (this.colorMenu)
      this.colorMenu = false
    else
      this.colorMenu = true;
  }

  savePart() {
    this.partSection = false;
    this.addSubPartSection = true;
    this.scanSection = false;
  }

  addSubPart() {
    this.partSection = false;
    this.addSubPartSection = false;
    this.scanSection = true;
  }

  scan() {
    this.showProgressBar = true;
    this.showSuccessMsg = false;
    this.progressBarValue=0;
    this.timeOutFunction();
  }
  timeOutFunction() {
    setTimeout(() => {
      this.progressBarValue = this.progressBarValue + 25;
      console.log("time out hit");
      if (this.progressBarValue >= 100) {
        this.showProgressBar = false;
        this.showSuccessMsg = true;
      }
      else {
        this.timeOutFunction();
      }
    }, 1000);
  }

}
